import { Stack, Box, Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { TFunction } from 'i18next';

import { BasicButton, CalculatorInputSliderField, CalculatorMonthlyInstallment, SectionLabel } from 'components';
import { AppConstants } from '../../constants';
import { CreditOptionsResponse, CreditResponse } from 'types';
import classes from './index.module.css';
import { ROUTE_CREDIT_REQUEST_BASIC } from 'constants/route';

const {
  CREDIT_AMOUNT_MIN,
  CREDIT_AMOUNT_MAX,
  CREDIT_AMOUNT_STEP,
  CREDIT_PAYMENT_MIN,
  CREDIT_PAYMENT_MAX,
  CREDIT_PAYMENT_STEP,
} = AppConstants;

interface ICalculatorForm {
  bg?: string;
  disabled?: boolean;
  disclaimerVariant?: string;
  form: any;
  inputVariant?: string;
  labelVariant?: string;
  options: CreditOptionsResponse;
  sectionVariant?: string;
  sliderColor?: string;
  sliderVariant?: string;
  t: TFunction;
  variant?: string;
  withButton?: boolean;
}

const CalculatorForm = ({
  bg,
  disabled,
  disclaimerVariant = '',
  form,
  inputVariant,
  labelVariant,
  options,
  sectionVariant = 'light',
  sliderColor,
  t,
  variant = 'dark',
  withButton,
}: ICalculatorForm) => {
  const navigate = useNavigate();

  return (
    <Stack
      gap={36}
      className={`${classes.calculatorBox} ${classes[variant]}`}
      bg={bg}
    >
      <Stack>
        <SectionLabel
          label={t('credit.basic.information.calculator')}
          variant={sectionVariant}
        />
        <Stack gap={20}>
          <CalculatorInputSliderField
            label={t('input.creditAmount.label')}
            labelVariant={labelVariant}
            inputVariant={inputVariant}
            sliderColor={sliderColor}
            rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
            rightSectionWidth={40}
            min={options['creditAmount']?.min ?? CREDIT_AMOUNT_MIN}
            max={options['creditAmount']?.max ?? CREDIT_AMOUNT_MAX}
            step={CREDIT_AMOUNT_STEP}
            key={form.key('creditAmount')}
            {...form.getInputProps('creditAmount')}
            disabled={disabled}
          />
          <CalculatorInputSliderField
            label={t('input.paymentPeriod.label')}
            labelVariant={labelVariant}
            inputVariant={inputVariant}
            sliderColor={sliderColor}
            rightSection={<Text size={'sm'} >{t('input.paymentPeriod.suffix')}</Text>}
            rightSectionWidth={60}
            min={options['paymentPeriod']?.min ?? CREDIT_PAYMENT_MIN}
            max={options['paymentPeriod']?.max ?? CREDIT_PAYMENT_MAX}
            step={CREDIT_PAYMENT_STEP}
            key={form.key('paymentPeriod')}
            {...form.getInputProps('paymentPeriod')}
            disabled={disabled}
          />
          <CalculatorMonthlyInstallment
            form={form}
            labelVariant={labelVariant}
            inputVariant={inputVariant}
          />
          <Text ta='left' className={`${classes.disclaimer} ${classes[disclaimerVariant]}`}>
            {t('credit.disclaimer')}
          </Text>
        </Stack>
      </Stack>
      {withButton ?
        <Box ta={'center'}>
          <BasicButton onClick={() => navigate(ROUTE_CREDIT_REQUEST_BASIC)}>{t('action.more')}</BasicButton>
        </Box>
        : undefined}
    </Stack>
  );
}

export default CalculatorForm;